export const environment = {
  production: false,
  useHash: true,
  // apiUrl: 'http://localhost:90',
  apiUrl: 'https://com-cia-des-fde-a11-001-f0eqdrdfefgkbpdb.a01.azurefd.net',
  apiAuth: {
    validEmail: '/b2c/signup/start',
    generateToken: '/b2c/signup/challenge',
    verifyCode: '/b2c/signup/continue',
    accessToken: '/b2c/signin/token',
    loginDocument: '/b2c/signin/login',
    documentOtp: '/b2c/sspr/document',
    sendOtp: '/b2c/sspr/send-otp',
    otpPassword: '/b2c/sspr/verify-otp',
    newPassword: '/b2c/sspr/new-password',
    verifyDocument: '/b2c/document/validar',
    migratedDocument: '/b2c/document/migrated',
    migratedEmail: '/b2c/document/migrated/mail',
  },
  termsUrl:
    'https://www.pluz.pe/content/dam/distribuidora-per%C3%BA-rebranding/documentos-pluz/TERMINOS_Y_CONDICIONES_GENERALES.pdf',
  privacyUrl: 'https://www.pluz.pe/es/footer/politica-de-privacidad.html',
  consentUrl: 'https://www.pluz.pe/es/footer/clausula-de-usos-adicionales.htm',
};
